import React from 'react';
import { Loader } from './loader';

const Fallback = () => {
  return <div className="text-center p-4">
    <Loader />
  </div>
}

export { Fallback }
